import config from '~/config';
import http from './http';

/**
 * @typedef AddressDetail
 * @property {string} id
 * @property {string} zip
 * @property {string} city
 * @property {string} stateCode
 * @property {string} county
 */

/**
 * Resolves address details from a zip code
 * @param {number} zipcode The Zip code to look up
 * @returns {Promise<AddressDetail[]>}
 */
export const getAddressDetails = async zipcode => {
    try {
        const results = await http.get(
            `${config.urls.base}/lookup/zipcode/{zipcode}`,
            { zipcode }
        );

        return results;

    } catch (err) {
        console.error(err);
        return null;
    }
};

export const getStateCodes = () => {
    return [
        { label: 'Alaska', value: 'AK' },
        { label: 'Alabama', value: 'AL' },
        { label: 'Arkansas', value: 'AR' },
        { label: 'Arizona', value: 'AZ' },
        { label: 'California', value: 'CA' },
        { label: 'Colorado', value: 'CO' },
        { label: 'Connecticut', value: 'CT' },
        { label: 'District of Columbia', value: 'DC' },
        { label: 'Deleware', value: 'DE' },
        { label: 'Florida', value: 'FL' },
        { label: 'Georgia', value: 'GA' },
        { label: 'Hawaii', value: 'HI' },
        { label: 'Iowa', value: 'IA' },
        { label: 'Idaho', value: 'ID' },
        { label: 'Illinois', value: 'IL' },
        { label: 'Indiana', value: 'IN' },
        { label: 'Kansas', value: 'KS' },
        { label: 'Kentucky', value: 'KY' },
        { label: 'Lousiana', value: 'LA' },
        { label: 'Massachussetts', value: 'MA' },
        { label: 'Maryland', value: 'MD' },
        { label: 'Maine', value: 'ME' },
        { label: 'Michigan', value: 'MI' },
        { label: 'Minnesota', value: 'MN' },
        { label: 'Missouri', value: 'MO' },
        { label: 'Mississippi', value: 'MS' },
        { label: 'Montana', value: 'MT' },
        { label: 'North Carolina', value: 'NC' },
        { label: 'North Dakota', value: 'ND' },
        { label: 'Nebraska', value: 'NE' },
        { label: 'New Hampshire', value: 'NH' },
        { label: 'New Jersey', value: 'NJ' },
        { label: 'New Mexico', value: 'NM' },
        { label: 'Nevada', value: 'NV' },
        { label: 'New York', value: 'NY' },
        { label: 'Ohio', value: 'OH' },
        { label: 'Oklahoma', value: 'OK' },
        { label: 'Oregon', value: 'OR' },
        { label: 'Pennsylvania', value: 'PA' },
        { label: 'Rhode Island', value: 'RI' },
        { label: 'South Carolina', value: 'SC' },
        { label: 'South Dakota', value: 'SD' },
        { label: 'Tennesee', value: 'TN' },
        { label: 'Texas', value: 'TX' },
        { label: 'Utah', value: 'UT' },
        { label: 'Virginia', value: 'VA' },
        { label: 'Vermont', value: 'VT' },
        { label: 'Washington', value: 'WA' },
        { label: 'Wisoncsin', value: 'WI' },
        { label: 'West Virginia', value: 'WV' },
        { label: 'Wyoming', value: 'WY' },
    ];
};

export default {
    getAddressDetails,
    getStateCodes
};